import request from '@/utils/request'


// 查询用户HRV记录列表
export function listHrv(query) {
  return request({
    url: '/joe/user-hrv/list',
    method: 'get',
    params: query
  })
}

// 查询用户HRV记录分页
export function pageHrv(query) {
  return request({
    url: '/joe/user-hrv/page',
    method: 'get',
    params: query
  })
}

// 查询用户HRV记录详细
export function getHrv(data) {
  return request({
    url: '/joe/user-hrv/detail',
    method: 'get',
    params: data
  })
}

// 新增用户HRV记录
export function addHrv(data) {
  return request({
    url: '/joe/user-hrv/add',
    method: 'post',
    data: data
  })
}

// 修改用户HRV记录
export function updateHrv(data) {
  return request({
    url: '/joe/user-hrv/edit',
    method: 'post',
    data: data
  })
}

// 删除用户HRV记录
export function delHrv(data) {
  return request({
    url: '/joe/user-hrv/delete',
    method: 'post',
    data: data
  })
}
